import React from "react";
import Routing from "./routing";
import { Provider } from "react-redux";
import { store } from "./store";
import { NODE_ENV } from "./redux/action/config";
const App = () => {
  // Clear Cosole
  // if (NODE_ENV === "production") {
  //   console.log = () => {};
  //   console.error = () => {};
  //   console.debug = () => {};
  // }
  return (
    <React.Fragment>
      <Provider store={store}>
        <Routing />
      </Provider>
    </React.Fragment>
  );
};

export default App;
